<template>
  <div>
    <v-card>
      <ModuleHeader class="ma-1">Galeria</ModuleHeader>
      <v-btn
        class="ma-2"
        color="red"
        dark
        @click="goRoute('/restaurante/departamentos')"
        >Regresar</v-btn
      >
      <v-btn class="ma-2" color="primary" @click="btnAdd()"
        >Agregar Imagen</v-btn
      >
      <v-btn
        :disabled="!imageSelected"
        class="ma-2"
        color="primary"
        @click="deleteImage()"
        >Eliminar Imagen</v-btn
      >
    </v-card>

    <v-card class="mt-2">
      <v-container class="pa-4 text-center">
        <v-row
          class="fill-height"
          align="center"
          justify="center"
          v-if="imageArray.length > 0"
        >
          <template v-for="(item, i) in imageArray">
            <v-col :key="i" cols="12" md="4">
              <v-hover v-slot="{ hover }">
                <v-card
                  :elevation="hover ? 12 : 2"
                  @click="showImage(item.img)"
                >
                  <v-img :src="item.img" height="225px">
                    <v-card-title
                      class="text-h6 white--text"
                      :class="{ 'hover-on': hover }"
                    >
                      <v-row
                        class="fill-height flex-column"
                        justify="space-between"
                      >
                        <div class="align-self-start">
                          <v-btn
                            icon
                            :key="i"
                            @click.stop="selectImage(item.name)"
                          >
                            <v-checkbox
                              :value="item.name === imageSelected"
                              @change="handleImageSelection(item.name)"
                              :class="{ 'custom-checkbox': hover }"
                            ></v-checkbox>
                          </v-btn>
                        </div>
                      </v-row>
                    </v-card-title>
                  </v-img>
                </v-card>
              </v-hover>
            </v-col>
          </template>
        </v-row>
        <div v-else>
          <v-card class="mt-5">
            <v-card-title>
              No hay imágenes disponibles. Carga tu primera imagen haciendo
              click en el boton "Agregar Imagen"
            </v-card-title>
          </v-card>
        </div>
      </v-container>

      <modal v-model="showDialog">
        <v-img
          :src="selectedImage"
          class="bg-grey-lighten-2 mx-1"
          cover
        ></v-img>
        <v-container class="custom-container">
          <v-btn class="btn-wrap-text" @click="handleClickBoard(selectedImage)">
            <span class="v-btn__content">
              {{ selectedImage }}
            </span>
          </v-btn>
        </v-container>
      </modal>

      <modal
        v-model="showModal"
        :showFooter="false"
        title="Agregar imagen"
        :key="loadIndex"
      >
        <v-card flat>
          <v-card-title class="text-h5"> Cargar imagenes </v-card-title>
          <v-card-text>
            <v-btn @click="$refs.FileInput.click()" x-small color="primary"
              >Seleccionar imagen</v-btn
            >
            <input
              ref="FileInput"
              type="file"
              style="display: none"
              accept="image/png, image/jpeg"
              @change="onFileSelect"
            />

            <vue-cropper
              v-show="imgLoading"
              preview=".preview"
              ref="cropper"
              :src="selectedFile"
              :autoCrop="false"
            ></vue-cropper>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              text
              @click="
                showModal = false;
                imgLoading = false;
              "
            >
              Cancelar
            </v-btn>
            <v-btn
              :loading="loaderImage"
              :disabled="loaderImage"
              color="green darken-1"
              text
              @click="saveImage()"
            >
              Subir foto
            </v-btn>
          </v-card-actions>
        </v-card>
      </modal>
    </v-card>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
export default {
  name: "GaleriaEditor",
  components: { VueCropper },
  data: () => ({
    icons: ["mdi-trash-can"],
    imageArray: [],
    imageSelected: null,
    selectingImage: false,

    transparent: "rgba(255, 255, 255, 0)",
    showModal: false,
    imgLoading: false,
    selectedFile: "",
    loaderImage: null,
    mime_type: "",
    cropedImage: "",

    showDialog: false,
    selectedImage: null,
    loadIndex: 0,
  }),
  methods: {
    async handleClickBoard(url) {
      let textToCopy = url;
      try {
        await navigator.clipboard.writeText(textToCopy);
      } catch (err) {
        console.error("Error al copiar: ", err);
      }
    },

    btnAdd() {
      this.loadIndex++;
      this.showModal = true;
      this.imgLoading = false;
      this.selectedFile = null;
    },
    showImage(img) {
      this.selectedImage = img;
      this.showDialog = true;
    },
    onFileSelect(e) {
      const file = e.target.files[0];
      this.mime_type = file.type;

      if (typeof FileReader === "function") {
        this.showModal = true;
        const reader = new FileReader();
        reader.onload = (event) => {
          this.selectedFile = event.target.result;
          this.imgLoading = true;
          this.$refs.cropper.replace(this.selectedFile);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    saveImage() {
      this.loaderImage = true;
      if (!this.selectedFile) {
        this.$swal({ title: "Error", text: "Favor de ingresar una imagen" });
        this.loaderImage = false;
      } else {
        this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
          const formData = new FormData();
          formData.append("AreaId", this.$route.params.idDepartamento);
          formData.append("tenant", this.$store.getters.getFirebaseApp.tenant);
          formData.append("Imagen", blob);

          this.$store.getters.getFirebaseApp.fba
            .callForm("AYB-Galerias-subirImagen", formData, {
              "Content-Type": "multipart/form-data",
            })
            .then((result) => {
              if (result.data.ok) {
                this.$swal({
                  title: "Guardado",
                  text: "El cliente se guardo correctamente",
                  icon: "success",
                });
                this.loaderImage = false;
                this.showModal = false;
                this.getImagesAvailable();
              }
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
              this.loaderImage = false;
            });
        }, this.mime_type);
      }
    },
    async getImagesAvailable() {
      const url =
        this.$store.getters.getFirebaseApp.tenant +
        "/AYB_Galerias/" +
        this.$route.params.idDepartamento +
        "/";

      let app = this.$store.getters.getFirebaseApp;

      const storage = getStorage(
        app.mainApp,
        "pargolfsolutions-e4659.appspot.com"
      );
      const listRef = ref(storage, url);

      const res = await listAll(listRef);
      const tasks = res.items.map((item) => getDownloadURL(item));

      const urls = await Promise.all(tasks);

      this.imageArray = urls.map((url, idx) => ({
        img: url,
        name: res.items[idx].name,
      }));
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    goRoute(routePath) {
      this.$router.push({ path: routePath });
    },
    handleImageSelection(name) {
      // Al cambiar el checkbox, selecciona la imagen
      if (this.imageSelected === name) {
        this.imageSelected = null; // Desmarca si se selecciona la misma imagen de nuevo
      } else {
        this.imageSelected = name; // Marca la nueva imagen
      }
      this.selectingImage = true; // Prevenir que se abra la imagen al seleccionar
    },
    selectImage(name) {
      this.selectingImage = true; // Evita abrir la imagen al seleccionar
    },
    deleteImage() {
      let datos = {
        AreaId: this.$route.params.idDepartamento,
        tenant: this.$store.getters.getFirebaseApp.tenant,
        Imagen: this.imageSelected,
      };
      this.$swal({
        title: "¿Deseas eliminar esta imagen?",
        text: "Se eliminará permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Galerias-eliminarImagen", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Imagen eliminada",
              "La imagen se eliminó correctamente",
              "success"
            );
            this.getImagesAvailable();
          } else {
            this.$swal(
              "Error eliminando imagen",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
  },
  mounted: async function () {
    await this.getImagesAvailable();
  },
};
</script>

<style scoped>
.v-card {
  transition: box-shadow 0.4s ease-in-out, background-color 0.4s ease-in-out;
}

.hover-on {
  -webkit-box-shadow: inset 0px 118px 70px -30px rgba(0, 0, 0, 0.63) !important;
  -moz-box-shadow: inset 0px 118px 70px -30px rgba(0, 0, 0, 0.63) !important;
  box-shadow: inset 0 54px 23px -28px rgb(0 0 0 / 63%) !important;
}

.custom-checkbox {
  color: rgb(255, 255, 255) !important;
}

.showImg {
  width: unset;
  height: unset;
  aspect-ratio: auto;
}

.custom-container {
  
}

.btn-wrap-text {
  height: auto !important;
  max-width: 100%;
  white-space: normal;
  padding: 10px 16px !important; /* Sobrescribe el padding predeterminado */
  display: flex;
  align-items: center; /* Centra el contenido verticalmente */
  text-align: left; /* Alinea el texto a la izquierda */
  overflow: hidden; /* Oculta el contenido extra */
}

.btn-wrap-text .v-btn__content {
  flex-grow: 1; /* Ocupa todo el espacio disponible */
  max-width: 100%;
  white-space: nowrap; /* Evita saltos de línea */
  text-overflow: ellipsis; /* Añade puntos suspensivos si el texto es muy largo */
  overflow: hidden; /* Oculta el texto que no cabe */
}
</style>
